import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import GroupIcon from '@material-ui/icons/Group';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import SettingsIcon from '@material-ui/icons/Settings';
import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 150;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  title: {
    textAlign: 'center',
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    '@media (max-width: 530px)': {
      display: 'none',
    },
  },
  drawerPaper: {
    width: drawerWidth,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media (max-width: 615px)': {
      padding: 0,
    },
  },
  avatarDiv: {
    display: 'flex',
    alignItems: 'baseline',
  },
  avatar: {
    marginRight: '10px',
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  sliderGroup: {
    display: 'flex',
    wrap: 'no-wrap',
  },
  slider: {
    width: theme.spacing(25),
    marginRight: '20px',
  },
  button: {
    marginBottom: '50px',
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
  menuButton: {
    display: 'none',
    '@media (max-width: 530px)': {
      display: 'inherit',
      position: 'fixed',
      top: 0,
      left: 12,
    },
  },
}));

const AccountLayout = ({ children, changeToDisplay, toDisplay }) => {
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <List>
      <ListItem
        selected={toDisplay === 'users'}
        button
        onClick={() => changeToDisplay('users')}
      >
        <ListItemIcon>
          <GroupIcon />
        </ListItemIcon>
        <ListItemText primary='Users' />
      </ListItem>

      <ListItem
        selected={toDisplay === 'attendance'}
        button
        onClick={() => changeToDisplay('attendance')}
      >
        <ListItemIcon>
          <CalendarTodayIcon />
        </ListItemIcon>
        <ListItemText primary='Attendance' />
      </ListItem>

      <ListItem
        selected={toDisplay === 'others'}
        button
        onClick={() => changeToDisplay('others')}
      >
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary='Others' />
      </ListItem>
    </List>
  );

  return (
    <div className={classes.root}>
      <IconButton
        color='inherit'
        aria-label='open drawer'
        edge='start'
        onClick={handleDrawerToggle}
        className={classes.menuButton}
      >
        <MenuIcon />
      </IconButton>

      <nav>
        <Drawer
          className={classes.mobileDrawer}
          variant='temporary'
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer}
        </Drawer>

        <Drawer
          className={classes.drawer}
          variant='persistent'
          anchor='left'
          open
        >
          {drawer}
        </Drawer>
      </nav>

      <main className={classes.content}>{children}</main>
    </div>
  );
};

export default AccountLayout;
